<template>
  <div class="flex justify-center w-full h-auto p-5 text-gray-800">
    <div class="w-full max-w-3xl">
      <ExternalClientInfo
        v-if="client"
        :client-document="client"
        :organization="organization"
        :hash="hash"
        :type="type"
      />
      <ExternalTicketList
        v-if="client"
        :client-document="client"
        :organization="organization"
        :type="type"
      />
    </div>

    <ExternalSnackbar
      :show="snackBar.show"
      @closed="snackBar.show = false"
    >
      {{ snackBar.message }}
    </ExternalSnackbar>
  </div>
</template>

<script>
import ExternalClientInfo from '@/components/ExternalClientInfo'
import ExternalTicketList from '@/components/ExternalTicketList'
import ExternalSnackbar from '@/components/commons/ExternalSnackbar'
import { decrypt } from '@/repositories/integrations/mobly/services/csExternal/decrypt'
import { MOBLY } from '@/utils/possible-organizations-values'
import { setTheme } from '@/utils/theme'

export default {
  name: 'ExternalTicketListView',

  components: {
    ExternalClientInfo,
    ExternalTicketList,
    ExternalSnackbar
  },

  data () {
    return {
      client: null,
      organization: null,
      type: 'customer',
      snackBar: {
        show: false,
        message: ''
      },
      hash: null
    }
  },

  mounted () {
    this.setClient()
  },

  methods: {
    async setClient () {
      try {
        const decrypted = await this.decrypt()
        this.client = decrypted.document
        this.organization = decrypted.organization || MOBLY
        this.type = decrypted.type || 'customer'
        setTheme(this.organization)
      } catch (err) {
        this.snackBar.message = 'Não foi possível abrir a página requisitada.'
        this.snackBar.show = true
      }
    },

    async decrypt () {
      const hash = this.$route.query.h
      this.hash = encodeURIComponent(hash)
      const organization = this.$route.query.org
      const request = await decrypt({ hash }, organization)
      const decrypted = request.data
      return decrypted
    }
  }
}
</script>
